import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchGraphSocialCounts } from "./trafficSourceAPI";

const initialState = {
  status: "idle",
  error: null,
  data: {},
  weeks: [],
  google: [],
  facebook: [],
  linkedin: [],
  instagram: [],
  direct: [],
  linktree: [],
  reddit: [],
  others: [],
  pinterest: [],
  hubspot: [],
  microsoft: [],
  afmc: [],
  chatgpt: [],
};

export const graphSocialCounts = createAsyncThunk(
  "trafficSource/socialCount",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-socialCounts`
      const response = await fetchGraphSocialCounts(dbpath, user, 'graph-socialCounts');
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const trafficSourceSlice = createSlice({
  name: "trafficSource",
  initialState,
  reducers: {
    resetTrafficSource: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(graphSocialCounts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(graphSocialCounts.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        const result = action.payload;
        try {
          state.data = result;
          let socialResult = socialCountsHandler(result);
          // console.log("socialResult", socialResult)
          state.weeks = socialResult.weeks_label
          state.google = socialResult.Google
          state.facebook = socialResult.Facebook
          state.direct = socialResult.Direct;
          state.pinterest = socialResult.Pinterest;
          state.hubspot = socialResult.Hubspot;
          state.linkedin = socialResult.Linkedin;
          state.reddit = socialResult.Reddit;
          state.instagram = socialResult.Instagram;
          state.microsoft = socialResult.Microsoft;
          state.linktree = socialResult.Linktree;
          state.others = socialResult.Others;
          state.afmc = socialResult.AffiliateMarketing;
          state.chatgpt = socialResult.ChatGPT;

        } catch (error) {
          console.warn("data not found", result);
        }
      })
      .addCase(graphSocialCounts.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      });
  },
});

export const {resetTrafficSource} = trafficSourceSlice.actions;

export const SelectWeeks = (state) => state.trafficSource.weeks;
export const SelectSocialCountsStatus = (state) => state.trafficSource.status;

export default trafficSourceSlice.reducer;

export const socialCountsHandler = (data) => {
  let weeks_label = data[1];
  weeks_label.forEach((element, index) => {
    weeks_label[index] = element.replaceAll("/", "-");
  });
  let Google = removeStrings(data[0][0]["data"]);
  let Facebook = removeStrings(data[0][1]["data"]);
  let Direct = removeStrings(data[0][2]["data"]);
  let Pinterest = removeStrings(data[0][3]["data"]);
  let Hubspot = removeStrings(data[0][4]["data"]);
  let Linkedin = removeStrings(data[0][5]["data"]);
  let Reddit = removeStrings(data[0][6]["data"]);
  let Instagram = removeStrings(data[0][7]["data"]);
  let Microsoft = removeStrings(data[0][8]["data"]);
  let Linktree = removeStrings(data[0][9]["data"]);
  let Others = removeStrings(data[0][10]["data"]);
  let AffiliateMarketing = removeStrings(data[0][11]["data"]);
  let ChatGPT = data[0][12] ? removeStrings(data[0][12]["data"]) : [];
  return {
    weeks_label,
    Google,
    Facebook,
    Direct,
    Pinterest,
    Hubspot,
    Linkedin,
    Reddit,
    Instagram,
    Microsoft,
    Linktree,
    Others,
    AffiliateMarketing,
    ChatGPT,
  };
};
function removeStrings(data) {
  return data.map((value) => {
    if (typeof value === "string") {
      return 0;
    } else {
      return value;
    }
  });
}